import {CLILoginCard, CLILoginLayout} from './CLILoginLayout';
import css from './CLILogin.module.css';

/** Landing pages the CLI's loopback server redirects to after the exchange. */
export const CLILoginSuccessPage = () => (
  <CLILoginLayout icon="checkmark">
    <CLILoginCard heading="Login complete">
      <p className={css.subhead}>
        You&apos;re signed in to the W&B CLI. You can close this tab and return
        to your terminal.
      </p>
    </CLILoginCard>
  </CLILoginLayout>
);

export const CLILoginCanceledPage = () => (
  <CLILoginLayout icon="close">
    <CLILoginCard heading="Login canceled">
      <p className={css.subhead}>
        You can close this tab and return to your terminal.
      </p>
    </CLILoginCard>
  </CLILoginLayout>
);
